import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateSamplingBlock } from "../api/accommodation.api";
import { toast } from "@/hooks/use-toast";
import { AxiosError } from "axios";

interface ErrorResponse {
  message: string;
  errors?: Record<string, string[]>;
}

interface MutationContext {
  onSuccess?: () => void;
  onError?: (error: AxiosError<ErrorResponse>) => void;
}

export const useSamplingBlock = () => {
  const queryClient = useQueryClient();

  const { mutate: unlockSampling, isPending } = useMutation({
    mutationFn: (accommodationId: string) => {
      return updateSamplingBlock(accommodationId, {
        samplingBlockReasonId: null,
        samplingBlockDate: null,
      });
    },
    onSuccess: (_, accommodationId, context: MutationContext) => {
      // Invalidar la consulta del alojamiento para refrescar los datos
      queryClient.invalidateQueries({ queryKey: ["accommodation", accommodationId] });
      
      toast({
        title: "Muestreo desbloqueado",
        description: "El alojamiento ha sido desbloqueado para muestreo correctamente.",
      });

      if (context?.onSuccess) {
        context.onSuccess();
      }
    },
    onError: (error: AxiosError<ErrorResponse>, accommodationId, context: MutationContext) => {
      toast({
        title: "Error",
        description: error?.response?.data?.message || "Ocurrió un error al desbloquear el muestreo.",
        variant: "destructive",
      });

      if (context?.onError) {
        context.onError(error);
      }
    },
  });

  return {
    unlockSampling,
    isUnlocking: isPending,
  };
}; 